import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=04aa5c3a&"
import script from "./CommentItem.vue?vue&type=script&lang=js&"
export * from "./CommentItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CommentItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports